import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { watchScheduledRequestProblems } from '../../../interpreter-queue/scheduledRequest';
import { showNotification } from '../../../notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../../../notifications/constants';
/**
 * Says what went wrong with scheduling an interpreter (plan #75) when the
 * server answers after the dialog was closed: a notice in the room (web; the
 * native twin also speaks it). The dialog says it itself while it is open.
 *
 * @returns {null}
 */
export default function ScheduledRequestNotices() {
    const dispatch = useDispatch();
    useEffect(() => watchScheduledRequestProblems(problem => {
        dispatch(showNotification({
            titleKey: undefined,
            title: problem,
            descriptionKey: undefined,
            uid: 'schedule-interpreter-problem'
        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
    }), [dispatch]);
    return null;
}
